import React, { useLayoutEffect } from 'react';
import * as am4core from '@amcharts/amcharts4/core';
import * as am4charts from '@amcharts/amcharts4/charts';
import am4themes_animated from '@amcharts/amcharts4/themes/animated';

am4core.useTheme(am4themes_animated);

const ProductMarketShareHomeLoanChart = ({ selectedProvince, selectedLocalMarket, data }) => {

  useLayoutEffect(() => {
    let chart = am4core.create('product-market-share-home-loan', am4charts.XYChart);

    // Disable the amCharts logo
    chart.logo.disabled = true;

    if (data.length > 0) {
      chart.data = data;

      let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
      categoryAxis.dataFields.category = 'Year';
      categoryAxis.renderer.grid.template.location = 0;
      categoryAxis.renderer.grid.template.disabled = true;  // Remove gridlines
      categoryAxis.renderer.minGridDistance = 30;

      // Set numberFormatter to avoid commas in the year labels
      categoryAxis.numberFormatter.numberFormat = "#";
      categoryAxis.renderer.line.disabled = true;

      let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
      valueAxis.renderer.grid.template.disabled = true;
      valueAxis.renderer.labels.template.disabled = true;

      const bankNames = ['Absa', 'Capitec', 'FNB', 'Nedbank', 'Standard Bank', 'TymeBank'];

      let colors = [
        am4core.color('#DF1641'),
        am4core.color('#FF3393'),
        am4core.color('#00CAFF'),
        am4core.color('#006E2C'),
        am4core.color('#0033A1'),
        am4core.color('#FFC000'),
      ];

      bankNames.forEach((bank, index) => {
        let series = chart.series.push(new am4charts.LineSeries());
        series.dataFields.valueY = bank;
        series.dataFields.categoryX = 'Year';
        series.name = bank;
        series.strokeWidth = 1.7;
        series.tensionX = 0.8;
        series.stroke = colors[index];
        series.tooltipText = '{name}: [bold]{valueY}[/]';

        series.tooltip.getFillFromObject = false; 
        series.tooltip.background.fill = colors[index]; 
        series.tooltip.label.fill = am4core.color('#FFFFFF'); 

        let boxBullet = series.bullets.push(new am4charts.Bullet());
        let roundedRectangle = boxBullet.createChild(am4core.RoundedRectangle);
        roundedRectangle.width = 35;
        roundedRectangle.height = 35;
        roundedRectangle.fill = colors[index];
        roundedRectangle.stroke = series.stroke;
        roundedRectangle.strokeWidth = 1;
        roundedRectangle.horizontalCenter = 'middle';
        roundedRectangle.verticalCenter = 'middle';
        roundedRectangle.cornerRadius(4, 5, 5, 4);

        let labelBullet = series.bullets.push(new am4charts.LabelBullet());
        labelBullet.label.text = '{valueY}';
        labelBullet.label.fill = am4core.color('#FFF');  // Set text color to white
        labelBullet.label.fontSize = 17;
        labelBullet.label.fontWeight = '500';
        labelBullet.label.horizontalCenter = 'middle';
        labelBullet.label.verticalCenter = 'middle';

        // Adjust the label's position to be better centered within the rectangle
        labelBullet.label.adapter.add('y', (y, target) => {
          return -roundedRectangle.height / 2 + 17; // Adjust vertical position of the label
        });
      });

      // Add rankings as labels for Home Loan Chart
           chart.events.on("datavalidated", function() {    //An event listener allowing to execute a function when a specific event occurs on the chart
             let sb_direction = chart.data[9];  
             chart.data.forEach((item, index) => {
               if (index === chart.data.length - 1){
                 return
               }
               let label = chart.plotContainer.createChild(am4core.Label);
               label.text = `${item['Standard Bank Rank']}`; 
               label.fontSize = 20;
               label.fontWeight = 'bold';
               label.fill = am4core.color('#0473EA'); // 
               label.align = 'center';
               label.isMeasured = false;
               label.x = categoryAxis.categoryToPoint(item['Year']).x - label.measuredWidth / 2;
               label.y = -20; 
       
               if (index === chart.data.length - 2){
                 if (sb_direction['sb_up'] == 'Down'){
                   label.background.fill = am4core.color('#FF0000'); // Red
                 }   
                 else if (sb_direction['sb_up'] == 'Up'){
                   label.background.fill = am4core.color('#00ff00'); // Green          
                 }          
                 else {
                   label.background.fill = am4core.color('#ffffff'); // White
                 }          
               }   
             });
           });
      chart.legend = new am4charts.Legend();
      chart.legend.position = 'bottom';
      chart.legend.itemContainers.template.paddingTop = 30;
      chart.legend.labels.template.paddingRight = 60;
      chart.legend.labels.template.width = 1000;
      chart.legend.itemContainers.template.marginTop = 20;
      chart.legend.itemContainers.template.width = 100;
      chart.legend.markers.template.width = 20;
      chart.legend.markers.template.height = 20;
      chart.legend.labels.template.paddingRight = 30;
      chart.legend.labels.template.paddingLeft = 8;
      chart.legend.labels.template.fontSize = 12;

      chart.cursor = new am4charts.XYCursor();
    }

    return () => {
      chart.dispose();
    };
  }, [data]);

  return <div id="product-market-share-home-loan" style={{ width: '100%', height: '500px' }}></div>;
};

export default ProductMarketShareHomeLoanChart;
